import Question from './Question';
import { YesNoAction } from './standartActions';

export default Question;

export const standartActions = {
  YesNoAction,
};
